import { PageHeader } from "../components/site/PageHeader";
import { Reveal } from "../components/site/Reveal";
import { HoursPanel } from "../components/site/HoursPanel";
import { ContactCard } from "../components/site/ContactActions";
import { ContactForm } from "../components/site/ContactForm";

export default function Contact() {
  return (
    <>
      <PageHeader
        testId="contact-header"
        eyebrow="Contact"
        lines={["Parlons", <em key="c" className="text-[#E5B66C]">ensemble</em>]}
        intro="Une question, une réservation de groupe ou une précision sur la carte ? Appelez CAP SUD, restaurant et pizzeria à Morangis, ou écrivez-nous."
      />
      <section className="pb-24 sm:pb-32">
        <div className="container-site grid gap-5 lg:grid-cols-2">
          <Reveal className="h-full"><ContactCard testId="contact-page-card" /></Reveal>
          <Reveal className="h-full" delay={0.1}><HoursPanel testId="contact-hours-panel" /></Reveal>
          <Reveal className="lg:col-span-2" delay={0.1}><ContactForm /></Reveal>
        </div>
      </section>
    </>
  );
}
